import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-history-details',
  templateUrl: './payment-history-details.component.html',
  styleUrls: ['./payment-history-details.component.scss']
})
export class PaymentHistoryDetailsComponent {

}
